import axios from 'axios'

import config from "../config"

const ENDPOINT_TESTING_SERVER = `${config.apiUrl}/siteTesting`;

export const getSitesList = async () => {
    try {
        const response = await axios.get(`${ENDPOINT_TESTING_SERVER}/sites`);
        return response.data;
    }
    catch (e) {
        throw new Error(e.message);
    }
}




